export default __webpack_public_path__ + "static/media/Biwo_Horizontal.1035bd8a.png";